import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "id", "size", "children"];
import React from 'react';
import Heading from 'components/Heading';
import { usePanelTitleId } from './PanelWrapper';
var PanelTitle = function PanelTitle(_ref) {
  var as = _ref.as,
    id = _ref.id,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'extra-small' : _ref$size,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var panelTitleId = usePanelTitleId(id);
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: as || 'h3',
    size: size,
    id: panelTitleId
  }, otherProps, {
    lineHeight: 1.4,
    display: "block"
  }), children);
};
export default PanelTitle;